export const MainConfig = {
    AppDetails: {
        app_name: "Boat-X", 
        app_description: "Marine transport service",
        app_identifier: "com.exicube.boatx",
        ios_app_version: "1.0", 
        android_app_version: 1
    },
    FirebaseConfig: {
            apiKey: "AIzaSyBLi6yAaT-Q24fbibbkuIWvKMNm9NB-RnI",
            authDomain: "boat-xapp.firebaseapp.com",
            databaseURL: "https://boat-xapp-default-rtdb.firebaseio.com",
            projectId: "boat-xapp",
            storageBucket: "boat-xapp.appspot.com",
            messagingSenderId: "874260190930",
            appId: "1:874260190930:web:7652529a70e3fe53e1ff0b",
            measurementId: "G-0VFPB40WRB"
    },
    Google_Map_Key: "AIzaSyBLi6yAaT-Q24fbibbkuIWvKMNm9NB-RnI",
    facebookAppId: "113230171010255",
    PurchaseDetails: {
        CodeCanyon_Purchase_Code: "bbedc774-8abe-4759-806d-098b236daa81",
        Buyer_Email_Address: "jacobjelmore@gmail.com"
    }
}